import { InjectionToken } from "@angular/core";
import { ICloudRestClient } from "./i-cloud-rest.client";

export const cloudRestClientInjectionToken: InjectionToken<ICloudRestClient> = new InjectionToken<ICloudRestClient>("digital-signage.user-dashboard.dashboard-web.CloudRestClient");
